import { createReducer } from 'redux-starter-kit';
import { putVideoOptions } from './videoOptionActions';


/**
 * A selector for the video options loaded in the domain state.
 * @param {object} state The redux state of the application.
 * @returns A keyed object mapping to the video option object
 * @example const videoOptions = selectVideoOptionsMap(state)
 */
export const selectVideoOptions = state => state.via.domain.videoOption;

const initialVideoOptions = {

};

/**
 * A reducer for managing the Video Options in the domain.
 */
const videoOptionReducer = createReducer(initialVideoOptions, {
  // Inserts/Updates the video options
  [putVideoOptions]: (state, action) => {
    const videoOptions = action.payload;
    return {
      ...state,
      ...videoOptions,
    };
  },
});


export default videoOptionReducer;
